import { createWebHistory, createRouter } from "vue-router";
import NotesMain from '../components/NotesMain'
import Contact from '../components/Contact'
import Impressum from '../components/Impressum'
import Datenschutz from '../components/Datenschutz'
import NotFound from '../components/NotFound'

const routes = [
  { name: 'home', path: '/', component: NotesMain },
  { name: 'contact', path: '/contact', component: Contact },
  { name: 'impressum', path: '/impressum', component: Impressum },
  { name: 'datenschutz', path: '/datenschutz', component: Datenschutz },
  { path: '/:pathMatch(.*)*', component: NotFound },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;